var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22656 11.9413C7.22656 13.0162 8.05144 13.8827 9.07629 13.8827H11.1677C12.0592 13.8827 12.7841 13.1245 12.7841 12.1913C12.7841 11.1748 12.3425 10.8165 11.6842 10.5832L8.3264 9.4167C7.66816 9.18341 7.22656 8.82512 7.22656 7.80861C7.22656 6.87541 7.95146 6.11719 8.84299 6.11719H10.9344C11.9592 6.11719 12.7841 6.98373 12.7841 8.05857",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5V14.9985",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 18.3283H7.50045C3.33439 18.3283 1.66797 16.6619 1.66797 12.4958V7.49654C1.66797 3.33049 3.33439 1.66406 7.50045 1.66406H12.4997C16.6658 1.66406 18.3322 3.33049 18.3322 7.49654V12.4958C18.3322 16.6619 16.6658 18.3283 12.4997 18.3283Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSquare);
export default __webpack_public_path__ + "static/media/dollar-square.1467c125d3808a26f1b12034e088b847.svg";
export { ForwardRef as ReactComponent };